import { AqiStandardId, DatasourceId, Point } from '../types';
import { Viewport } from './viewport';

export enum WindowMessageType {
  MapUpdate = 'map-update',
}

export interface WindowMessage {
  type: WindowMessageType;
}

export class MapUpdateMessage implements WindowMessage {
  public type: WindowMessageType = WindowMessageType.MapUpdate;

  constructor(
    public viewport: Viewport | null,
    public searchedLocation: Point | null,
    public datasourceId: DatasourceId | null,
    public aqiStandardId: AqiStandardId | null
  ) {}
}
